import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-allocation-progress-actions',
    templateUrl: './allocation-progress-actions.component.html',
    styleUrl: './allocation-progress-actions.component.scss',
    standalone: false
})
export class AllocationProgressActionsComponent {  
  @Input() selectedQuantity: number = 0;
  @Input() percentage: number = 0;
  @Input() expectedQuantity: number = 0;
  @Output() onAllocateClick = new EventEmitter();
  @Output() onResetClick = new EventEmitter();


  getSelectedPercentage(): number {
      return (this.selectedQuantity*100)/this.expectedQuantity;
  }

  onAllocateClickHandler() {
    this.onAllocateClick.emit();
  }
  onResetClickHandler() {
    this.onResetClick.emit();
  }

}
